 // Header Docking
export function headerDock() {
  const body = document.body;
  
  window.addEventListener('scroll', function () {
    let scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > 150) {
      body.classList.add('page-scroll--init');
    } else {
      body.classList.remove('page-scroll--init');
    }

    if (scrollTop > 200) {
      body.classList.add('page-scroll--init-transition');
    } else {
      body.classList.remove('page-scroll--init-transition');
    }

    if (scrollTop > 450) {
      body.classList.add('page-scroll--fade');
    } else {
      body.classList.remove('page-scroll--fade');
    }

  });

}